import { breakpoints } from "../constants/breakpoint";

const checkMobile2 = () => window.screen.width < breakpoints.xs;

export const isMobile = checkMobile2();
